export default __webpack_public_path__ + "static/media/linkedin_integration.fac3a21e.svg";